import { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import ModalCreateLink from './ModalCreateLink';
import ModalModifyLink from './ModalModifyLink'
import { Card, Typography } from "@material-tailwind/react";
import { toast, ToastContainer } from 'react-toastify'; // Import pour les notifications
import 'react-toastify/dist/ReactToastify.css'; // Styles pour les notifications

function ListLink() {
    const [datas, setDate] = useState([]);
    const [sortedBy, setSortedBy] = useState();
    const [counter, setCounter] = useState(0);
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    // const [open, setOpen] = useState('block');
    const [choosenLink, setChoosenLink] = useState({
        Id:'',
        type:'',
        plateforme:'',
        lien: ''
    });


    useEffect(() => {

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_link_download`).then(res => {
            setDate(res.data);
        }).catch(err => console.log("Erreur récupération PDV:", err));
    }, []);

    const TABLE_HEAD = [
        { key: "type", text: "Type" },
        { key: "plateforme", text: "Plateforme" },
        { key: "lien", text: "Lien" },
        { key: "edit", text: "Edit" }

    ];

    const sorted = [...datas].sort((a, b) => {
        if (!sortedBy) return 0;
        const aVal = a[sortedBy];
        const bVal = b[sortedBy];

        if (typeof aVal === "number" && typeof bVal === "number") {
            return counter % 2 === 0 ? aVal - bVal : bVal - aVal;
        } else if (typeof aVal === "string" && typeof bVal === "string") {
            return counter % 2 === 0 ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
        }
        return 1;
    });

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Fonction pour copier le lien
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success("Lien copié dans le presse-papier !", {
                position: "bottom-right",
                autoClose: 2000,
            });
        }).catch(err => {
            console.error('Erreur lors de la copie :', err);
            toast.error("Erreur lors de la copie");
        });
    };

    const ListTable = () => {
        return (
            <Card className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="border-b border-slate-200 bg-slate-50">
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head.key}
                                        className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1); }}
                                    >
                                        <span className="inline-flex items-center gap-1">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.filter((item) => {
                                return search === ''
                                    || item.type.toLowerCase().includes(search.toLowerCase())
                                    || item.plateforme.toLowerCase().includes(search.toLowerCase())
                                    || item.lien.toLowerCase().includes(search.toLowerCase());
                            }).map((data, index) => {
                                const classes = "whitespace-nowrap px-4 py-3 text-sm text-slate-700";
                                return (
                                    <tr key={data.Id} className="border-b border-slate-100 transition-colors hover:bg-indigo-50/40">
                                        <td className={classes}>
                                            <Typography variant="small" className="font-medium text-slate-800">
                                                {data.type}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <Typography variant="small" className="font-normal text-slate-700">
                                                {data.plateforme}
                                            </Typography>
                                        </td>

                                        {/* Modification ici pour le clic et la copie */}
                                        <td
                                            className={`${classes} cursor-pointer transition-colors hover:bg-indigo-50`}
                                            onClick={() => copyToClipboard(data.lien)}
                                            title="Cliquez pour copier"
                                        >
                                            <div className="flex items-center gap-2">
                                                <Typography variant="small" className="font-normal text-indigo-600 hover:text-indigo-700">
                                                    {data.lien}
                                                </Typography>

                                            </div>
                                        </td>

                                        <td className={classes}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 cursor-pointer text-slate-500 hover:text-indigo-600" onClick={() => { setShowModalModify(true); setChoosenLink({ ...choosenLink, Id: data.Id, type: data.type, plateforme: data.plateforme, lien: data.lien}) }}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
                                            </svg>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card>
        );
    };

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-6">
                    <h1 className="text-xl font-semibold text-slate-800">Liens de téléchargement</h1>
                    <p className="text-sm text-slate-500">Gérez les liens des applications par plateforme. Cliquez sur un lien pour le copier.</p>
                </div>
                <div className="mb-4 max-w-md">
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === 'hidden' ? 'block' : 'hidden')}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher un lien..."
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
                <main className="mt-4">
                    {/* <DefaultSidebar isOpen={open} /> */}
                    {ListTable()}
                    <button type="button" onClick={scrollToTop} className="fixed bottom-20 right-6 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md hover:bg-slate-50">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </button>
                    <button type="button" onClick={() => setShowModal(true)} className="fixed bottom-6 right-6 flex h-12 w-12 items-center justify-center rounded-full bg-indigo-500 text-white shadow-lg hover:bg-indigo-600">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                        </svg>
                    </button>
                </main>
            </div>
            <ModalModifyLink isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenLink={choosenLink} />
            
            <ModalCreateLink isVisible={showModal} onClose={() => setShowModal(false)} />
            <ToastContainer /> 
        </Fragment>
    );
}

export default ListLink;